enum TestTypes {
  DATE_IN_THE_PAST = 'date-in-the-past',
  PHONE_NUMBER = 'invalid-phone-number',
  NOT_SPECIFIC_TYPE = 'no-error-type',
  IS_QUESTION_ANSWER_ARRAY = 'is-question-answer-array',
  VALIDATE_IBAN = 'validate-iban',
  CHECK_FOR_EMPTY_FIELDS = 'check-for-empty-fields',
  CHECK_FOR_NEGATIVE_FIELDS = 'check-for-negative-fields',
  DATE_SHOULD_BE_AFTER_START = 'date-should-be-after-start',
  INVALID_NUMBER = 'invalid-number',
  AT_LEAST_18_YO = 'at-least-18-yo',
  EMAIL_ALREADY_EXISTS = 'email-exists',
  GERMAN_IBAN = 'is-german-iban',
  DATE_SHOULD_BE_IN_REQUESTED_YEAR = 'date-in-requested-year',
  ZIP_CODE = 'zip-code-length',
  DATE_IN_STUDY_PERIOD = 'date-in-study-period',
}

export const noErrorType = TestTypes.NOT_SPECIFIC_TYPE

export default TestTypes
